// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2rxP1","location":"Header_location__5vCaQ"};